'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

const SearchBar = ({ onSearch, placeholder = "Search insights, jurisdictions, or topics..." }: SearchBarProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (isHydrated) {
      onSearch(searchQuery);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (isHydrated) {
      onSearch(value);
    }
  };

  if (!isHydrated) {
    return (
      <form className="relative mb-xl">
        <div className="relative">
          <Icon 
            name="MagnifyingGlassIcon" 
            size={20} 
            variant="outline"
            className="absolute left-md top-1/2 -translate-y-1/2 text-text-secondary"
          />
          <input
            type="text"
            placeholder={placeholder}
            className="w-full pl-12 pr-md py-sm bg-background border border-border text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-primary transition-colors duration-base"
          />
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={handleSearch} className="relative mb-xl">
      <div className="relative">
        <Icon 
          name="MagnifyingGlassIcon" 
          size={20} 
          variant="outline"
          className="absolute left-md top-1/2 -translate-y-1/2 text-text-secondary"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="w-full pl-12 pr-md py-sm bg-background border border-border text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-primary transition-colors duration-base"
        />
      </div>
    </form>
  );
};

export default SearchBar;